import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/antragsarten/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="RequestType"
      returnRoute="/auswahlfelder/requestTypes"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const RequestTypesRoute = Route;
